import type { RoleModule } from '../types';

/**
 * The directory surface's routes and door overrides. See ../types.ts.
 * Every route path here must start with `/directory/`.
 *
 * The Directory itself is the existing page at `/directory` (edited in place
 * in `src/pages/doctor/directory/`), which every role's Directory door opens —
 * it picks the doctor's, reception's or the stock manager's view from the
 * shell's surface. This surface's own Directory door points at it; its other
 * doors (Overview, Reports, Money, Staff, Flows) are the clinic manager's.
 */
const directory: RoleModule = {
  routes: [],
  doorRoutes: {
    overview: '/clinic-manager/today',
    reports: '/clinic-manager/reports',
    money: '/clinic-manager/settings/money',
    staff: '/clinic-manager/settings/roles',
    flows: '/clinic-manager/settings/flows',
    directory: '/directory',
  },
};

export default directory;
